import PromoOptOutPage from '@/modules/settings/subscription/promo-opt-out-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/unsubscribe/$token')({
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useParams();
  return <PromoOptOutPage token={token} />;
}
